module.exports = __webpack_public_path__ + "static/img/share_popup.fe17596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/share_popup.png
// module id = uvib
// module chunks = 4